module.exports = __webpack_public_path__ + "img/svg.60e8b73e.svg";